import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const EditLoanEffortless = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [oldImage, setOldImage] = useState("");

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const fetchEffortlessDetails = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getSingleLoanEffortless/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const effortless = res.data.effortless;
      setSelectedLoanId(effortless.loan_id);
      setDescription(effortless.description);
      setOldImage(effortless.image);
    } catch (error) {
      console.error("Error fetching effortless details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedLoanId || !description.trim()) {
      alert("Loan and description are required");
      return;
    }

    const formData = new FormData();
    formData.append("loan_id", selectedLoanId);
    formData.append("description", description);
    if (image) {
      formData.append("image", image);
    }

    try {
      await axios.put(`${COMMON_API}/loan/editLoanEffortless/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });
      navigate(-1);
    } catch (error) {
      console.error("Error updating effortless:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
    fetchEffortlessDetails();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Edit Loan Effortless</h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Loan select */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
            <select
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              value={selectedLoanId}
              onChange={(e) => setSelectedLoanId(e.target.value)}
              required
            >
              <option value="">-- Select Loan --</option>
              {loans.map((loan) => (
                <option key={loan.id} value={loan.id}>
                  {loan.name}
                </option>
              ))}
            </select>
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Description</label>
            <textarea
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Edit description..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Old Image Preview */}
          {oldImage && (
            <div>
              <p className="text-gray-600 mb-1">Current Image:</p>
              <img
                src={`${COMMON_API}/ImgUploads/${oldImage}`}
                alt="Effortless"
                className="w-full h-40 object-cover rounded-lg mb-3"
              />
            </div>
          )}

          {/* New Image Upload */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Upload New Image (optional)</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0])}
              className="w-full"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
          >
            Update Effortless
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditLoanEffortless;
